'use client'

import {LoadingIcon} from '@/src/shared/ui/icons/loading'
import styled from 'styled-components'

export const LoadingContentPage = () => {
  return <Component>
    <LoadingIcon size={24}/>
  </Component>
}

const Component = styled.div`
  min-height: 320px;
  width: 100%;
  flex: 1;
  display: flex;
  justify-content: center;
  align-items: center;
`
